<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Attendance Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="emp" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                            item-text="name" item-value="id" label="Salary Year" outlined @change="getSalaryMonth()" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
                            :items="sal_month_list" item-text="sal_mon" item-value="id" label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="8" md="5" v-if="sal_month != null" align="center">
                        <!-- <center> -->
                        <v-btn class="button" @click="fetchReport()" :loading="loader">Employee Attendance
                            Report</v-btn>
                        <!-- </center> -->
                    </v-col>
                </v-row>
                <!-- {{attendance_details}} -->

                <v-row justify="center" dense v-if="inst_data!=''">
                    <v-col cols="12" sm="3" md="3"><strong>Name :</strong> {{inst_data.name}}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Employee Designation : </strong> {{
                        inst_data.inst_designation }} </v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Employee Type :</strong> {{ inst_data.inst_employeetype }}
                    </v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Employee Section :</strong> {{ inst_data.inst_employeesection
                        }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Date Of Joining :</strong> {{ inst_data.inst_date_of_joining
                        }}</v-col>
                    <v-col cols="12" sm="6" md="6"><strong>Applied In Out Plan :</strong> {{ inst_data.inst_in_out_plan
                        }}</v-col>
                </v-row>

                <div id="my-table-id">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px" v-if="attendance_details!=''">
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <!-- <th class="">Name</th>
                                <th class="">Employee Designation</th>
                                <th class="">Employee Type</th>
                                <th class="">Employee Section</th>
                                <th class="">Date Of Joining</th> -->
                                <th class="">Attendance Date</th>
                                <!-- <th class="">Applied In Out Plan</th> -->
                                <th class="">Expected In Time</th>
                                <th class="">Expected Out Time</th>
                                <th class="">Expected No Of Hours</th>
                                <th class="">In Time</th>
                                <th class="">Out Time</th>
                                <th class="">Holiday</th>
                                <th class="">Leave Type</th>
                                <th class="">Leave Approval Status</th>
                                <th class="">Hpl Count</th>
                                <th class="">Freeze Attendance</th>
                                <th class="">Biometric Sync Remark</th>
                                <th class="">Sync Leave</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr></tr>
                            <tr v-for="(s, index) in attendance_details" :key="s.instid"
                                :class="s.isweeklyoff ? 'weaklyoff2' : 'weaklyoff'">
                                <td>{{ index + 1 }}</td>
                                <!-- <td>{{ s.name }}</td>
                                <td>{{ s.inst_designation }}</td>
                                <td>{{ s.inst_employeetype }}</td>
                                <td>{{ s.inst_employeesection }}</td>
                                <td>{{ s.inst_date_of_joining }}</td> -->
                                <td>{{ s.todaysdate }}</td>
                                <!-- <td>{{ s.inst_in_out_plan }}</td> -->
                                <td>{{ s.expectedintime }}</td>
                                <td>{{ s.expectedouttime }}</td>
                                <td>{{ s.expectednoofhours }}</td>
                                <td>{{ s.intime }}</td>
                                <td>{{ s.outtime }}</td>
                                <td>{{ s.holiday }}</td>
                                <td>{{ s.leavetype }}</td>
                                <td>{{ s.leaveapprovalstatus }}</td>
                                <td>{{ s.hpl_count }}</td>
                                <td>
                                    <!-- {{ s.freezeattendance }} -->
                                    <span v-if="s.freezeattendance">
                                        <v-icon class="mr-2 v-icon-size"
                                            color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </td>
                                <td>{{ s.remark }}</td>
                                <td><v-btn @click="syncLeave(s.att_id)" small class="button">Sync Leave</v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: null,
            year: null,
            year_list: [],
            freez_flag: null,
            fmsg: null,
            employee_list: [],
            emp: null,
            org_basic_data: null,
            attendance_details: [],
            inst_data:[]
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            fetchReport() {
                 this.attendance_details = []
                 this.inst_data = []
                const data = {
                    sal_month: this.sal_month,
                    emp: this.emp,
                };
                this.loader = true;
                axios
                    .post("/EmployeeBiometric/getEmployeeAttendanceReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.attendance_details = res.data.attendance_details;
                            this.inst_data = res.data.inst_data
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
             syncLeave(att_id){
                const data = {
                    att_id:att_id
                }
                axios
                    .post("/EmployeeBiometric/syncLeave",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Leave Sync Successfully...");
                            this.fetchReport()
                        } 
                        else if(res.data.flag =="NO") {
                             this.showSnackbar("#b71c1c", res.data.smsg);
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            onLoad() {
                axios
                    .post("/Payroll/getYear")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.year_list = res.data.year_list;
                            this.employee_list = res.data.inst_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getSalaryMonth() {
                const data = {
                    year: this.year,
                };
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    .weaklyoff {
        background: white !important;
    }
    .weaklyoff2 {
        background: yellow !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
